import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import About from './pages/About';
import Contact from './pages/Contact';
import DownloadApp from './pages/DownloadApp';
import PrivacyPolicy from './pages/PrivacyPolicy';
import EventParkingManagement from './pages/EventParkingManagement';
import ParkingLotManagementApp from './pages/ParkingLotManagementApp';
import DigitalParkingSolutions from './pages/DigitalParkingSolutions';
import VehicleEntryExitManagementSystem from './pages/VehicleEntryExitManagementSystem';
import AIParkingManagementPlatform from './pages/AIParkingManagementPlatform';
import ParkingLotAutomationSoftware from './pages/ParkingLotAutomationSoftware';
import ParkingRevenueManagementApp from './pages/ParkingRevenueManagementApp';
import TouristAttractionParkingSoftware from './pages/TouristAttractionParkingSoftware';
import CinemaMultiplexParkingSystem from './pages/CinemaMultiplexParkingSystem';


function App() {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/download" element={<DownloadApp />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/event-exhibition-parking-management" element={<EventParkingManagement />} />
          <Route path="/parking-lot-management-app" element={<ParkingLotManagementApp />} />
          <Route path="/digital-parking-solutions" element={<DigitalParkingSolutions />} />
          <Route path="/vehicle-entry-exit-management-system" element={<VehicleEntryExitManagementSystem />} />
          <Route path="/ai-parking-management-platform" element={<AIParkingManagementPlatform />} />
          <Route path="/parking-lot-automation-software" element={<ParkingLotAutomationSoftware />} />
          <Route path="/parking-revenue-management-app" element={<ParkingRevenueManagementApp />} />
          <Route path="/tourist-attraction-parking-software" element={<TouristAttractionParkingSoftware />} />
          <Route path="/cinema-and-multiplex-parking-system" element={<CinemaMultiplexParkingSystem />} />
        </Routes>
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}

export default App;